<template>
  <sign-page
    title-text="采购合同管理"
    :request="request"
    :column-list="columnList"
    table-size="small"
    @dataFileUpdate="dataFileUpdate"
    :title-menus="[{key: 'add', label: '新增'}]"
    :table-actions="tableActions"
    :form-parms-add="formParmsAdd"
    :initAddFormData="initAddFormData"
    :form-parms-update="formParmsUpdate"
    :table-actions-fixed="true"
    :need-data-file="true">
  </sign-page>
</template>

<script>
import {
  purchaseContractRequest as request,
  purchaseRequest
} from '../../api'

import {
  dateOperating
} from '@/fmlib'

export default {
  computed: {
    tableActions () {
      let data = [{
        key: 'data_file',
        label: '附件'
      },
      {
        key: 'edit',
        label: '修改'
      },
      {
        key: 'del',
        label: '删除'
      }]
      return data
    },
    currentOrgId () {
      return this.$store.getters.currentOrgId
    },
    formParmsAdd: {
      get () {
        let data = [{
          type: 'input',
          label: '合同名称',
          key: 'name',
          check: {
            required: true
          }
        },
        {
          type: 'datePicker',
          label: '签订日期',
          key: 'signedTime',
          check: {
            required: true
          }
        },
        {
          type: 'input',
          label: '签订单位',
          key: 'signedOrg'
        },
        {
          type: 'multipleChoose',
          label: '关联采购结果',
          selectDatas: this.purchaseList,
          key: 'purchaseIds'
        },
        {
          type: 'input',
          label: '合同金额',
          key: 'total',
          check: {
            required: true,
            rules: {
              type: 'number'
            }
          }
        },
        {
          type: 'input',
          label: '采购数量',
          key: 'num',
          check: {
            required: true,
            rules: {
              type: 'number'
            }
          }
        },
        {
          type: 'select',
          label: '采购负责人',
          key: 'principalUserId',
          selectDatas: this.$store.getters.userList,
          check: {
            required: true
          }
        },
        {
          type: 'input',
          label: '质保金',
          key: 'warranty',
          check: {
            rules: {
              type: 'number'
            }
          }
        },
        {
          type: 'datePicker',
          label: '质保金打款日期',
          key: 'warrantyTime'
        },
        {
          type: 'select',
          label: '创建部门',
          key: 'orgId',
          selectDatas: this.$store.getters.orgList,
          fmDisabled: !this.$authFunsProxy.get,
          check: {
            required: true
          }
        }]
        return data
      }
    },
    formParmsUpdate: {
      get () {
        let data = []
        this.formParmsAdd.forEach((item) => {
          let newItem = {}
          for (let key in item) {
            newItem[key] = item[key]
          }
          data.push(newItem)
        })
        return data
      }
    },
    columnList: {
      get () {
        let data = [{
          title: '合同号',
          field: 'code',
          sort: true
        },
        {
          title: '合同名称',
          field: 'name',
          sort: true
        },
        {
          title: '签订日期',
          field: 'signedTime',
          dataType: Date,
          sort: true,
          render: (h, rowData) => {
            return h('div', rowData && rowData.signedTime ? rowData.signedTime.slice(0, 10) : '-')
          }
        },
        {
          title: '签订单位',
          field: 'signedOrg',
          sort: true
        },
        {
          title: '合同金额',
          field: 'total',
          dataType: Number,
          sort: true
        },
        {
          title: '采购数量',
          dataType: Number,
          field: 'num',
          sort: true
        },
        {
          title: '采购负责人',
          field: 'principalUserName',
          sort: true
        },
        {
          title: '质保金',
          dataType: Number,
          field: 'warranty',
          sort: true
        },
        {
          title: '质保金打款日期',
          field: 'warrantyTime',
          dataType: Date,
          sort: true,
          render: (h, rowData) => {
            return h('div', rowData && rowData.warrantyTime ? rowData.warrantyTime.slice(0, 10) : '-')
          }
        },
        {
          title: '创建部门',
          field: 'orgName',
          sort: true
        },
        {
          title: '扫描件状态',
          field: 'fileStatus',
          sort: true,
          render: (h, rowData) => {
            return h('div', rowData && rowData.imgUploadTime ? '已上传' : '未上传')
          }
        },
        {
          title: '最近更新扫描件时间',
          field: 'imgUploadTime',
          dataType: Date,
          sort: true
        }]
        return data
      }
    }
  },
  created () {
    if (this.$authFunsProxy.add || this.$authFunsProxy.edit) {
      this.$store.dispatch('loadUserList')
      this.$store.dispatch('loadOrgList')
      this.loadPurchase()
    }
  },
  methods: {
    initAddFormData () {
      if (!this.$authFunsProxy.get && !this.currentOrgId) {
        this.$notify({
          title: '系统提示',
          message: '无当前组织架构，无法新建',
          type: 'info'
        })
        throw Error()
      }
      return {
        orgId: this.currentOrgId
      }
    },
    async loadData () {
      let data = []
      if (this.$authFunsProxy.get) {
        data = await request.get()
      } else if (this.$authFunsProxy.getMyOrg) {
        data = await request.getMyOrg()
      }
      data.forEach(v => v.purchaseIds = v.purchaseIds ? v.purchaseIds.split(',').map(v =>  Number(v)) : [])
      return data
    },
    async loadPurchase () {
      let data = await purchaseRequest.get()
      this.purchaseList = data.map(v => {
        let label = v.code || ''
        label += (v.goodsName || '') + ' ' + (v.UserName || '') + ' ' + (v.total || '') + '元'
        return {
          key: v.id,
          label
        }
      })
    },
    async dataFileUpdate (parm, pageVm) {
      await request.update(pageVm.chooseData.id, {
        fileIds: parm && parm.length > 0 ? parm.join(',') : null,
        imgUploadTime: parm && parm.length > 0 ? dateOperating.computeDay({days: 0, date: new Date(), format: 'yy-mm-dd hh:mm:ss'}) : null
      })
      pageVm.loadData()
    }
  },
  data () {
    return {
      request: Object.assign({}, request, {
        get: this.loadData
      }),
      pageVm: null,
      purchaseList: []
    }
  }
}
</script>

<style lang="less" scoped>
.img-c {
  height: 60vh;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  .no-img {
    font-size: 1.4rem;
    color: #999;
  }
  img {
    max-height: 100%;
    max-width: 100%;
  }
}
.file-d-footer {
  display: flex;
  justify-content: center;
  align-items: center;
}
.file-d-footer-wx {
  display: none;
  justify-content: center;
  align-items: center;
}
</style>